import moment from "moment-timezone";

import { fileAssemble, fileUpload, fileUploadFragment } from "../shared/settings/apiConfig";
import { postApi } from "../shared/services/apiHelper";

const length = 5;

const dateTimeFormat = 'YYYY-MM-DD HH:mm:ss';

export const getRandomChars = (size = length) => {
    let result = '';
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const charactersLength = characters.length;
    let counter = 0;
    while (counter < size) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
        counter += 1;
    }
    return result;
}

export const getBase64Content = (file) => {
    return new Promise((resolve, reject) => {
        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onloadend = () => {
            resolve(reader.result.replace(/^.*base64,/, ""));
        };
        reader.onerror = (error) => {
            reject(error);
        };
    });
};

export const uploadLargetAsset = async (asset, progressCallback=null) => {
    try {
        const fileName = asset.name;
        const fileSize = asset.size;
        
        let offset = 0;
        let chunkCount = 0;
        const chunkSize = Math.ceil(1024 * 1024 * 2); // equals to 2mb
        const totalChunks = Math.ceil(fileSize / chunkSize, chunkSize);

        const fileUploadPayload = {
            filename: fileName,
            size: fileSize,
            partCount: totalChunks
        };
        
        progressCallback && progressCallback({ uploading: true, progress: 0 });

        let response = await postApi(fileUpload, { data: fileUploadPayload });
        if ( response.data.status === 'success' ) {
            const partKey = response.data.partkey;

            while (chunkCount < totalChunks) {
                offset = chunkCount * chunkSize;

                const fileUploadFragmentPayload = {
                    partkey: partKey,
                    partid: chunkCount + 1,
                    content: await getBase64Content(asset.file.slice(offset, offset + chunkSize)),
                };

                response = await postApi(fileUploadFragment, { data: fileUploadFragmentPayload });

                if ( response.data.status === 'success' ) {
                    chunkCount++;

                    let progress = (( chunkCount / totalChunks ) * 100).toFixed(0);
                    progressCallback && progressCallback({ uploading: true, progress: progress == 100 ? 99 : progress });
                } else {
                    response = { status: false, message: 'Error while uploading' };
                    break;
                }
            }

            if ( chunkCount === totalChunks ) {
                let convertedStringName = fileName.replace(/\u202F/g, " ");
                asset.image = btoa(`BIG${convertedStringName}$${partKey}$${fileSize}$${totalChunks}`);
                response = { status: true, message: response.data.message };

                progressCallback && progressCallback({ uploading: false, progress: 99 });
            }

        } else {
            response = { status: false, message: response.data.message };
        }
        
        return response;
    } catch(error) {
        return { status: false, message: 'Error while uploading' };
    }
};

export const uploadLargeAssetAndAssesmble = async (asset, progressCallback=null) => {
    try {
        let response = await uploadLargetAsset(asset, progressCallback);

        if ( response.status ) {
            delete asset.file;
            
            response = await postApi(fileAssemble, { data: asset });

            if ( response.data.status === 'success' ) {
                return response.data.data.url;
            }
        }
    } catch (error) {
        console.log("Failed while uploading image", error);
    }

    return null;
}

export const convertTimezoneTimeToUtc = (dateTimeStr, timezoneStr=null) => {
    const timezone = timezoneStr || moment.tz.guess();
    return moment.tz(dateTimeStr, timezone).utc().format(dateTimeFormat);
};

export const convertUtcToLocalDateTime = (dateTimeStr) => {
    if ( dateTimeStr ) {
        return `${moment.utc(dateTimeStr).local().format('MM/DD/YYYY hh:mm A')} ${moment.tz(moment.tz.guess()).zoneAbbr()}`;
    } else
        return '- - -';
};

export const convertUtcToLocalTimeCustomFormat = (dateTimeStr, format) => {
    if ( dateTimeStr ) {
        return `${moment.utc(dateTimeStr).local().format(format)}`;
    } else
        return '- - -';
};

export const capitalizeFirstLetter = (content) => {
    try {
        if (content)
            return content.toLowerCase().split(" ").map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(" ");
        else return ''
    } catch (e) {
        return ''
    }
};

export const convertToTwoDigits = (n) => {
    return (n < 10 ? '0' : '') + n;
};

export const sleep = (time) => {
    return new Promise(resolve => {
        setTimeout(() => {
            resolve();
        }, time);
    })
}

export const openAssetPicker = (successCallback, errorCallback) => {
    let input = document.createElement('input');
    input.type = 'file';

    input.onchange = event => {
        successCallback && successCallback();
    }

    input.onerror = error => {
        errorCallback && errorCallback();
    };

    input.click();
};

export const getErrorMessage = (error) => {
    let message = 'Something went wrong';
    if ( error.response ) {
        if ( Array.isArray(error.response.data?.message) ) {
            message = error.response.data.message[0].message;
        } else {
            message = error.response.data.message;
        }
    } else {
        message = error.message;
    }

    return message;
}

export const PHQ9_RANGES = [
    {
        min: 0,
        max: 4,
        color: "hsl(158 60% 42%)",
        bg: "hsl(158 60% 42% / 10%)"
    },
    {
        min: 5,
        max: 9,
        color: "hsl(210 80% 55%)",
        bg: "hsl(210 80% 55% / 10%)"
    },
    {
        min: 10,
        max: 14,
        color: "hsl(38 92% 50%)",
        bg: "hsl(38 92% 50% / 10%)"
    },
    {
        min: 15,
        max: 19,
        color: "hsl(38 92% 50%)",
        bg: "hsl(38 92% 50% / 10%)"
    },
    {
        min: 20,
        max: 27,
        color: "hsl(0 80% 55%)",
        bg: "hsl(0 80% 55% / 10%)"
    }
];

export const GAD_RANGES = [
    {
        min: 0,
        max: 4,
        color: "hsl(158 60% 42%)",
        bg: "hsl(158 60% 42% / 10%)"
    },
    {
        min: 5,
        max: 9,
        color: "hsl(210 80% 55%)",
        bg: "hsl(210 80% 55% / 10%)"
    },
    {
        min: 10,
        max: 14,
        color: "hsl(38 92% 50%)",
        bg: "hsl(38 92% 50% / 10%)"
    },
    {
        min: 15,
        max: 21,
        color: "hsl(0 80% 55%)",
        bg: "hsl(0 80% 55% / 10%)"
    }
];

export const BAI_RANGES = [
    {
        min: 0,
        max: 7,
        color: "hsl(158 60% 42%)",
        bg: "hsl(158 60% 42% / 10%)"
    },
    {
        min: 8,
        max: 15,
        color: "hsl(210 80% 55%)",
        bg: "hsl(210 80% 55% / 10%)"
    },
    {
        min: 16,
        max: 25,
        color: "hsl(38 92% 50%)",
        bg: "hsl(38 92% 50% / 10%)"
    },
    {
        min: 26,
        max: 63,
        color: "hsl(0 80% 55%)",
        bg: "hsl(0 80% 55% / 10%)"
    }
];

export const BDI_RANGES = [
    {
        min: 0,
        max: 13,
        color: "hsl(158 60% 42%)",
        bg: "hsl(158 60% 42% / 10%)"
    },
    {
        min: 14,
        max: 19,
        color: "hsl(210 80% 55%)",
        bg: "hsl(210 80% 55% / 10%)"
    },
    {
        min: 20,
        max: 28,
        color: "hsl(38 92% 50%)",
        bg: "hsl(38 92% 50% / 10%)"
    },
    {
        min: 29,
        max: 63,
        color: "hsl(0 80% 55%)",
        bg: "hsl(0 80% 55% / 10%)"
    }
];

export const RANGE_BY_ASSESSMENT = {
    "PHQ-9": PHQ9_RANGES,
    "GAD-7": GAD_RANGES,
    "BAI": BAI_RANGES,
    "BDI-II": BDI_RANGES
};